const getOpenSessionList = (state, payload) => {
  state.openSessionList = payload.data;
}

const getSelectedSessionData = (state, payload) => {
  state.selectedSessionData = payload.data;

}

const getTotalBillableUnits = (state, payload) => {
  //console.log(payload.totalUnitsToBeBilled);
  state.totalBillableUnits = payload.totalUnitsToBeBilled;
}


const getOutlierSessionData = (state, payload) => {
  state.outlierSessionData = payload.data;
}

const getIncompleteData = (state, payload) => {
  state.incompleteData = payload.incompleteLots;
}

const getSuspiciousMessages = (state, payload) => {
  state.suspiciousMessages = payload.suspiciousMessages;
}

const getCompletedSessionData = (state, payload) => {
  state.completedSessionData = payload;
}

const getCompletedSessionLots = (state, payload) => {
  //state.completedSessionLots = payload.data;
  state.completedSessionLots = payload;
}

const getCommonConsumptionHistory = (state, payload) => {
  state.commonConsumptionHistory = payload.data || {};
}

const getAdhocSessionData = (state, payload) => {
  state.adhocSessionData = payload.data;
}

const getAdhocSessionLots = (state, payload) => {
  state.adhocSessionLots = payload.data;
}

const getBillValue = (state, payload) => {
  state.billValue = payload;
}

const uploadSession = (state, payload) => {
  state.uploadSessionResponse = payload;
}

const discardSession = (state, payload) => {
  state.discardSession = payload;
}

const clearActiveSessionState = (state) => {
  state.selectedSessionData = {};
  state.outlierSessionData = [];
  state.incompleteData = '';
  state.suspiciousMessages = '';
  state.totalBillableUnits = '';
  state.discardSession = null;
}

const completeSessionDownload = (state, payload) => {
  state.completeSessionDownloadData = payload
}

export default {
  getOpenSessionList,
  getSelectedSessionData,
  getOutlierSessionData,
  getIncompleteData,
  getCompletedSessionData,
  getCompletedSessionLots,
  getCommonConsumptionHistory,
  getAdhocSessionData,
  getAdhocSessionLots,
  getBillValue,
  uploadSession,
  discardSession,
  clearActiveSessionState,
  completeSessionDownload,
  getTotalBillableUnits,
  getSuspiciousMessages
}



// WEBPACK FOOTER //
// ./src/store/modules/sessions/mutations.js